import { HeroBlock } from "@/components/site/home/HeroBlock";
import { ChooseBlock } from "@/components/site/home/ChooseBlock";
import { InspireBlock } from "@/components/site/home/InspireBlock";
import { HowBlock } from "@/components/site/home/HowBlock";
import { StoryBlock } from "@/components/site/home/StoryBlock";
import { FaqBlock } from "@/components/site/home/FaqBlock";
import { useSeo } from "@/lib/site";

export default function HomePage() {
  useSeo({
    title: "LUMINA STUDIO | Láminas y pósters metálicos personalizados",
    description: "Transforma tus fotos en láminas metálicas personalizadas, con efecto flotante y bordes redondeados. Crea tu diseño con una fotografía o un collage.",
  });
  return (
    <>
      <HeroBlock />
      <ChooseBlock />
      <div id="inspirate" className="scroll-mt-24"><InspireBlock /></div>
      <HowBlock />
      <StoryBlock />
      <FaqBlock />
    </>
  );
}
